/* eslint-disable */

import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import apiInstance from "../utils/api";
import styled, { keyframes } from 'styled-components'
const ConfirmResultDialog = (props) => {
    <style>
        {`
      @media print {
        .print-disclaimer {
          display: block !important;
        }
      }

      .print-disclaimer {
        display: none;
        font-size: 12px;
        color: #555;
        border-top: 1px solid #ccc;
        margin-top: 20px;
        padding-top: 10px;
        text-align: left;
        font-family: Arial, sans-serif;
      }
    `}
    </style>
    const TH1 = styled.th`
        font-size: 25px;
        margin-bottom: 1px;
        padding: 1px;
        font-weight:bold;
      `
    const TD1 = styled.td`
        font-size: 22px;
        margin-bottom: 1px;
        padding: 1px;
    
      `

    const SPAN = styled.span`
        font-size: 20px;
      `
    const P = styled.p`
        color: white;
      `
    const filteredVouchers = props.vouchers
    console.log(props.vouchers, 'vo')

    const handlePrint = () => {
        props.handleConfirm()
    }
    const hasImage = filteredVouchers.some(testSelect => testSelect.img);
    return (
        <div style={{ minWidth: "1000px" }}>

            <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='lg'>
                <DialogTitle className="text-center">
                    <u>LABORATORY REPORT</u>
                </DialogTitle>
                <DialogContent>

                    <table className='table' style={{ pageBreakInside: "auto", marginTop: "10px" }}>


                        <thead style={{ height: "10px", }} className='bg-white'>
                            {hasImage ? (
                                <tr style={{
                                    pageBreakInside: "avoid", pageBreakAfter: "auto", marginBottom: "1px", height: "10px",
                                    borderStyle: "solid",
                                    borderColor: "black",
                                    borderWidth: "1px"
                                }}>
                                    <TH1>Test</TH1>
                                    <TH1 className='text-center'>Image</TH1>
                                    <TH1>Remark</TH1>
                                </tr>
                            ) : (
                                <tr style={{ outline: "3px solid black" }}>
                                    <TH1 >Test</TH1>
                                    <TH1>Result</TH1>
                                    <TH1>Reference Range</TH1>
                                    <TH1>Unit</TH1>
                                    <TH1>Remark</TH1>
                                </tr>
                            )}
                        </thead>
                        {filteredVouchers.map(testSelect => (
                            <>

                                <tbody>
                                    {testSelect.name.subTestFlag ? (
                                        <tr style={{ pageBreakInside: "auto", pageBreakAfter: "auto", marginBottom: "1px" }}>
                                            <TD1>
                                                <div className='col-md-12 border-0'>
                                                    <p>
                                                        <u>
                                                            <b>
                                                                {testSelect.name.name.includes('NS')
                                                                    ? testSelect.name.name.replace('NS', '')
                                                                    : testSelect.name.name}
                                                            </b>
                                                        </u>
                                                    </p>
                                                    {/* {
                                testSelect.name.subTest.map((test) => (
                                  <p>{test.name}</p>
                                ))
                              } */}
                                                    {testSelect.subTest.map(test => (
                                                        <span>
                                                            {test !== null ? (
                                                                test.type === 'underline' ? (
                                                                    <p>
                                                                        <u>
                                                                            <b>{test.name}</b>
                                                                        </u>
                                                                    </p>
                                                                ) : test.type === 'highlight' ? (
                                                                    <p style={{ color: 'red' }}>
                                                                        <b>{test.name}</b>
                                                                    </p>
                                                                ) : test.type === 'both' ? (
                                                                    <p style={{ color: 'red' }}>
                                                                        <u>
                                                                            <b>{test.name}</b>
                                                                        </u>
                                                                    </p>
                                                                ) : test.type === "multiline" ? (
                                                                    <p style={{ marginBottom: "45px" }}>{test.name}</p>
                                                                ) : (<p>{test.name}</p>)
                                                            ) : (
                                                                <p>{test.name}</p>
                                                            )}{' '}
                                                        </span>
                                                        // <p>{(test.type === "underline") ? <u> : ""}{test.name}{(test.type === "underline") ? </u> : ""}</p>
                                                    ))}
                                                </div>
                                            </TD1>

                                            <TD1>
                                                <div className='col-md-12 border-0'>
                                                    <div style={{ height: '40px' }}></div>
                                                    {testSelect.subTest.map(test => (
                                                        // <p
                                                        //   style={{ marginBottom: '6px' }}
                                                        // >{(test.result !== null) ? test.result : ""}</p>
                                                        <span>
                                                            {' '}
                                                            {test !== null ? (
                                                                test.type === 'underline' ||
                                                                    test.type === 'highlight' ||
                                                                    test.type === 'both' ? (
                                                                    <p style={{ color: 'white' }}>""</p>
                                                                ) : test.type === "multiline" ? (<p style={{ marginBottom: "45px" }} >
                                                                    {' '}
                                                                    {test.result !== '' ? (
                                                                        test.result
                                                                    ) : test.defaultResult !== '' ? (
                                                                        test.defaultResult
                                                                    ) : (
                                                                        <P>-</P>
                                                                    )}
                                                                </p>) : (
                                                                    <p >
                                                                        {' '}
                                                                        {test.result !== '' ? (
                                                                            test.result
                                                                        ) : test.defaultResult !== '' ? (
                                                                            test.defaultResult
                                                                        ) : (
                                                                            <P>-</P>
                                                                        )}
                                                                    </p>
                                                                )
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    ))}
                                                </div>
                                            </TD1>
                                            <TD1>
                                                <div className='col-md-12 border-0'>
                                                    <p style={{ height: '24px' }}></p>
                                                    {/* <div style={{ height: '40px' }}></div> */}
                                                    {testSelect.subTest.map(test => (
                                                        // <p style={{ marginTop: '22px' }}>{test.referenceRange}</p>
                                                        <span>
                                                            {' '}
                                                            {test !== null ? (
                                                                test.type === 'underline' ||
                                                                    test.type === 'highlight' ||
                                                                    test.type === 'both' ?
                                                                    <p style={{ color: 'white' }}>""</p>
                                                                    : ((test.referenceRange !== "") ?
                                                                        ((test.type === "multiline") ? <p contentEditable="true">{formatString(test.referenceRange)}</p> :
                                                                            //   <input
                                                                            //   className='border-0'
                                                                            //   type='text'
                                                                            //   id='subRefRange'
                                                                            //   defaultValue={test.referenceRange}
                                                                            //   style={{ height: '24px' }}
                                                                            // />
                                                                            <p contentEditable="true">{test.referenceRange}</p>
                                                                        ) : <P>-</P>)


                                                            ) : (
                                                                <p>-</p>
                                                            )}
                                                        </span>
                                                    ))}
                                                </div>
                                            </TD1>

                                            <TD1>
                                                <div className='col-md-12 border-0'>
                                                    <div style={{ height: '40px' }}></div>
                                                    {testSelect.subTest.map(test => (
                                                        // <p style={{ marginTop: '18px' }}>{test.unit}</p>
                                                        <span>
                                                            {' '}
                                                            {test !== null ? (
                                                                test.type === 'underline' ||
                                                                    test.type === 'highlight' ||
                                                                    test.type === 'both' ? (
                                                                    <p style={{ color: 'white' }}>""</p>
                                                                ) : test.type === "multiline" ? (<p style={{ marginBottom: "45px" }}>
                                                                    {test.unit === '' ? (
                                                                        <P>-</P>
                                                                    ) : (
                                                                        test.unit
                                                                    )}
                                                                </p>) : (
                                                                    <p>
                                                                        {test.unit === '' ? (
                                                                            <P>-</P>
                                                                        ) : (
                                                                            test.unit
                                                                        )}
                                                                    </p>
                                                                )
                                                            ) : (
                                                                <P>-</P>
                                                            )}
                                                        </span>
                                                    ))}
                                                </div>
                                            </TD1>

                                            <TD1>
                                                <div className='col-md-12 border-0'>
                                                    <div style={{ height: '40px' }}></div>
                                                    {testSelect.subTest.map(test => (
                                                        // <p
                                                        //   style={{ marginBottom: '6px' }}
                                                        // >{(test.remark !== null) ? test.remark : ""}</p>
                                                        <span>
                                                            {' '}
                                                            {test !== null ? (
                                                                test.type === 'underline' ||
                                                                    test.type === 'highlight' ||
                                                                    test.type === 'both' ? (
                                                                    <p style={{ color: 'white' }}>""</p>
                                                                ) : test.type === "multiline" ? (<p style={{ marginBottom: "45px" }}>
                                                                    {test.remark === '' ? (
                                                                        <P>-</P>
                                                                    ) : (
                                                                        test.remark
                                                                    )}
                                                                </p>) : (
                                                                    <p>
                                                                        {test.remark === '' ? (
                                                                            <P>-</P>
                                                                        ) : (
                                                                            test.remark
                                                                        )}
                                                                    </p>
                                                                )
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    ))}
                                                </div>
                                            </TD1>
                                        </tr>
                                    ) : (
                                        <tr key={testSelect._id} style={{ pageBreakInside: "auto", pageBreakAfter: "auto" }}>
                                            {testSelect.img ? (
                                                <>
                                                    <TD1>
                                                        {testSelect.name.name.includes('NS')
                                                            ? testSelect.name.name.replace('NS', '')
                                                            : testSelect.name.name}
                                                    </TD1>
                                                    <TD1>
                                                        <img src={`http://wincliniclabbackend.kwintechnologies.com:7070/static/cherry-k/${testSelect?.img?.imgUrl}`} width='100%' height='100%' />
                                                    </TD1>
                                                    <TD1>{testSelect.remark}</TD1>
                                                </>

                                            ) : (
                                                <>
                                                    <TD1>
                                                        {testSelect.name.name.includes('NS')
                                                            ? testSelect.name.name.replace('NS', '')
                                                            : testSelect.name.name}
                                                    </TD1>
                                                    <TD1>{testSelect.result}</TD1>

                                                    <TD1 className='w-full'>
                                                        {testSelect.name.specialComment ? (
                                                            'See Below'
                                                        ) : (
                                                            <div>
                                                                {testSelect.name.referenceRange.map(refer => (
                                                                    <p key={refer._id}>
                                                                        {/* {refer.gender} &nbsp;
                                    {refer.from}-{refer.to} &nbsp; */}
                                                                        {/* {refer.refRange} */}
                                                                        <input
                                                                            type='text'
                                                                            id='refRange'
                                                                            name='refRange'
                                                                            defaultValue={refer.refRange}
                                                                            style={{ borderStyle: 'hidden', width: '300px' }}
                                                                        />
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </TD1>

                                                    <TD1>
                                                        {testSelect.name.specialComment ? (
                                                            'See Below '

                                                        ) : (
                                                            <div className='w-full'>
                                                                {testSelect.name.referenceRange.map(refer => (
                                                                    <p key={refer._id}>{refer.unit}</p>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </TD1>
                                                    <TD1>{testSelect.remark}</TD1>
                                                </>

                                            )}



                                        </tr>
                                    )}
                                </tbody>
                            </>

                        ))}
                    </table>

                    <div className="print-disclaimer border p-4">
                        <strong>NOTICE:</strong><br />
                        This laboratory report is generated based on data entered and verified by authorized laboratory personnel.
                        Our software serves only as a reporting tool and does not interpret, validate, or alter medical data.<br /><br />
                        <strong>We are not responsible for any incorrect results, misdiagnoses, or consequences resulting from inaccurate data entry, laboratory procedures, or human error.</strong>
                        <strong>Please ensure all results are carefully reviewed and verified before printing or using them for clinical decisions.</strong>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.close}>Cancel</Button>
                    <Button onClick={handlePrint}>Confirm</Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default ConfirmResultDialog;
